/* twemoji sprite cells — one sheet.png + an index map; every rendered
   emoji is a sized background-position window into it. data lives in
   emoji.json, regenerated by scripts/build-emoji.mjs */

import data from "./emoji.json";

export interface EmojiRow {
  /** the literal emoji char (what goes into message text) */
  e: string;
  /** short searchable name */
  n: string;
  /** twemoji codepoint filename */
  c: string;
  cat: string;
}

export const EMOJIS = data.emoji as EmojiRow[];
export const EMOJI_SHEET = data.sheet;
const COLS = data.cols;

/* char → flat sheet index */
export const EMOJI_INDEX = new Map(EMOJIS.map((r, i) => [r.e, i]));

/* picker order — unique categories in sheet order */
export const EMOJI_CATS = [...new Set(EMOJIS.map((r) => r.cat))];

/* regex matching exactly the emoji we have art for — alternation of
   escaped literals (longest first so ZWJ sequences win) */
export const EMOJI_ALT = [...EMOJIS]
  .map((r) => r.e)
  .sort((a, b) => b.length - a.length)
  .map((e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
  .join("|");
export const EMOJI_RE = new RegExp(`(?:${EMOJI_ALT})`);

export function Emoji({
  char,
  size = 18,
  className = "",
}: {
  char: string;
  size?: number;
  className?: string;
}) {
  const i = EMOJI_INDEX.get(char);
  const row = i == null ? undefined : EMOJIS[i];
  if (i == null || !row)
    return <span className={className}>{char}</span>; /* no art — plain char */
  const x = (i % COLS) * size;
  const y = Math.floor(i / COLS) * size;
  return (
    <span
      role="img"
      aria-label={row.n}
      title={`:${row.n}:`}
      className={`inline-block select-none ${className}`}
      style={{
        width: size,
        height: size,
        verticalAlign: "-0.15em",
        backgroundImage: `url(${EMOJI_SHEET})`,
        backgroundSize: `${COLS * size}px auto`,
        backgroundPosition: `-${x}px -${y}px`,
      }}
    />
  );
}
